import React from "react";
import { NavLink } from "react-router-dom";


function MainMenu() {
  return (
    <>
      <ul className="navbar-nav me-auto mb-2 mb-lg-0 col-8 mx-5 ">
        <li className="nav-item  mx-3">
          <NavLink
            className="nav-link text-white"
            aria-current="page"
            to="/"
          >
            Home
          </NavLink>
        </li>
        <li className="nav-item mx-3">
          <NavLink className="nav-link text-white" to="/about">
            About
          </NavLink>
        </li>
        <li className="nav-item dropdown mx-3">
          <NavLink
            className="nav-link text-white dropdown-toggle"
            to="/service"
            id="navbarDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Services
          </NavLink>
          <ul className="dropdown-menu " aria-labelledby="navbarDropdown">
            <li>
              <NavLink className="dropdown-item text-white m" to="/training">
                Training
              </NavLink>
            </li>
            <li>
              <NavLink className="dropdown-item text-white" to="/service2">
                Another action
              </NavLink>
            </li>
            <li><hr className="dropdown-divider" /></li>
            <li>
              <NavLink className="dropdown-item text-white" to="/service3">
                Something else here
              </NavLink>
            </li>
          </ul>
        </li>
        <li className="nav-item dropdown mx-3">
          <NavLink
            className="nav-link text-white dropdown-toggle"
            to="/batchDetails"
            id="batchesDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Batches
          </NavLink>
          <ul className="dropdown-menu " aria-labelledby="navbarDropdown">
            <li>
              <NavLink className="dropdown-item text-white" to="/batchDetails">
                Batch 15
              </NavLink>
            </li>
            <li>
              <NavLink className="dropdown-item text-white" to="/batchDetails">
                Batch 14
              </NavLink>
            </li>
            <li>
              <NavLink className="dropdown-item text-white" to="/batchDetails">
                Batch 13
              </NavLink>
            </li>
            <li>
              <hr className="dropdown-divider" />
            </li>
            <li>
              <NavLink className="dropdown-item text-white" to="/">
                See All Batches
              </NavLink>
            </li>
          </ul>
        </li>
        <li className="nav-item mx-3">
          <NavLink className="nav-link text-white" to="/contact" >
            Contact us
          </NavLink>
        </li>
      </ul>
    </>
  );
}

export default MainMenu;
